import { Component, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ContactService, Pager, User, UserService } from 'lib-trend-core';
import { switchMap } from 'rxjs';

@Component({
    selector: 'contact-customer-portfolio-component',
    templateUrl: 'contact-customer-portfolio.v2.component.html',
    // templateUrl: 'contact-customer-portfolio.component.html',
    styleUrl: 'contact-customer-portfolio.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactCustomerPortifolioComponent extends AbstractComponent implements OnInit {

  toggleTableCard: boolean = false;
  idUser: string;
  user: User;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public contactService: ContactService,
    public userService: UserService,
  ) {
    super(injector);
    this.loadingContent = true;
  }

  ngOnInit(): void {
    this.idUser = super.getParam('id');
    this.userService.getById(this.idUser).subscribe({
      next: (user: User) => {
        this.user = user;
        this.loadingContent = false;
      },
      error: (err) => {
        console.error('Erro ao buscar usuário:', err);
        this.loadingContent = false;
      }
    });
    const savedView = localStorage.getItem('tableCardView');
    this.toggleTableCard = savedView ? JSON.parse(savedView) : false;
  }


  back() {
    this.router.navigate(['/contact']);
  }
}
